// extracted by mini-css-extract-plugin
export default {"wrapper":"PageNotFound_wrapper__SNY0k"};